export enum AudioEvents {
  PLAY = 'pp-play-sound',
  PAUSE = 'pp-pause-sound',
  STOP = 'pp-stop-sound',
}

export interface AudioEventPlayDetailType {
  name: string;
  channel: string;
  loop?: boolean;
}

export interface AudioEventStopDetailType {
  name: string;
}

export interface SoundResourceType {
  name: string;
  url: string;
}
